import React, { lazy, Suspense } from "react";
import { Redirect } from "react-router-dom";
import HomeLayout from "../layouts/HomeLayout";
import LoadingPage from 'src/views/Loading';
// import BlankLayout from 'src/layouts/BlankLayout';
import { pathPrefix } from 'src/util';
const SuspenseComponent = (Component, extraProps) => (props) => {
  return (
    <Suspense fallback={<LoadingPage />}>
      <Component {...props} {...extraProps}></Component>
    </Suspense>
  );
};

const SideLayout = lazy(() => import("../pages/index/SideLayout"));

const LoginComponent = lazy(() => import("../pages/login"));
const IndexComponent = lazy(() => import("../pages/index/index"));
const HomeComponent = lazy(() => import("../pages/home/home"));
const SystemComponent = lazy(() => import("../pages/system/system"));
const GroupComponent = lazy(() => import("../pages/system/user/group/group"));
const ManagerComponent = lazy(() =>
  import("../pages/system/user/manager/manager")
);
const SpecialRight = lazy(() => import("../pages/system/user/SpecialRight"));

const QuotationReleaseComponent = lazy(() => import("../pages/release/quotation/quotation"));
const DocReleaseComponent = lazy(() => import("../pages/release/doc/doc"));
const FaqReleaseComponent = lazy(() => import("../pages/release/faq/faq"));
const SoftwareReleaseComponent = lazy(() => import("../pages/release/SoftwareRelease/Version"));
const PatchReleaseComponent = lazy(() => import("../pages/release/SoftwareRelease/Patch"));
const ManualReleaseComponent = lazy(() => import("../pages/release/SoftwareRelease/Manual"));
const StrategyComponent = lazy(() => import("../pages/release/SoftwareRelease/Strategy"));
const VersionListComponent = lazy(() => import("../pages/release/SoftwareRelease/VersionList"));
const SoftwareMessageComponent = lazy(() => import("../pages/release/SoftwareRelease/SoftwareMessage"));

const SaleComponent = lazy(() => import("../pages/system/user/sale/sale"));
// const Cart = lazy(() => import("../pages/cart/Cart.jsx"));
const Collection = lazy(() => import("../pages/collection/Collection.jsx"));
const QaShowComponent = lazy(() => import("../pages/system/manager/qa/qaShow"));
const QaComponent = lazy(() => import("../pages/system/manager/qa/qa"));
const ManualComponent = lazy(() => import("../pages/system/manager/manual/manual"));
const ManualListComponent = lazy(() => import("../pages/system/manager/manual/manualList"));
const ContactComponent = lazy(() => import("../pages/system/manager/contacts/contacts"));
const VersionComponent = lazy(() => import("../pages/system/manager/version/version"));
const VersionListCompoment = lazy(() => import("../pages/system/manager/version/versionList"));
// const ProductModelComponent = lazy(() => import("../pages/system/manager/model/model"));
const OpeLogComponent = lazy(() => import("../pages/system/manager/log/log"));
const SettingComponent = lazy(() => import("../pages/system/manager/setting/setting"));
const AuthSettingComponent = lazy(() => import("../pages/system/manager/authorize/authorize"));
const ProjectComponent = lazy(() => import("../pages/system/user/project/project"));
const ProjectConfigComponent = lazy(() => import("../pages/system/user/project/ProjectConfig"));
const AgentComponent = lazy(() => import("../pages/agent/agent"));
const AgentManageComponent = lazy(() =>
  import("../pages/agent/agentManage/agentManage")
);

const QuoteIndex = lazy(() => import("../pages/quote/admin/IndexPage.jsx"));
const FormalQuotation = lazy(() =>
  import("../pages/quote/admin/FormalQuotation.jsx")
);
const QuickQuotation = lazy(() => import("../pages/quote/add/index.jsx"));
const DraftQuotation = lazy(() => import("../pages/quote/admin/DraftQuotation.jsx"));
const TrashQuotation = lazy(() => import("../pages/quote/admin/TrashQuotation.jsx"));
const QuotationDetailPage = lazy(() => import("../pages/quote/quotationDetail/QuotationDetailPage.jsx"));

const UserCenter = lazy(() => import('../pages/userCenter/userCenter.jsx'));
const AccountInfo = lazy(() => import('../pages/userCenter/accountInfo.jsx'));
const UserInfo = lazy(() => import('../pages/userCenter/userInfo.jsx'));
const CompanyInfo = lazy(() => import('../pages/userCenter/companyInfo.jsx'));

const ProductComponent = lazy(() => import("../pages/product/product"));
const ProductAdminComponent = lazy(() =>
  import("../pages/product/admin/admin")
);

const ProductDetail = lazy(() => import("../pages/product/detail/detail"));
const ProductCenter = lazy(() => import("../pages/product/center/center"));
const ProductSuite = lazy(() => import("../pages/product/suite/suite"));

const ShipmentBarcode = lazy(() => import("../pages/product/ShipmentBarcode"));

const SolutionComponent = lazy(() =>
  import("../pages/product/solution/solution")
);
const SolutionCenter = lazy(() =>
  import("../pages/product/solutionCenter/solutionCenter")
);
const SolutionDetail = lazy(() =>
  import("../pages/product/solutionDetail/solutionDetail")
);

const ProductChange = lazy(() =>
  import("../pages/product/change/productChange")
);

const Promotion = lazy(() =>
  import("../pages/product/promotion/promotion")
);

const AuthorizeInput = lazy(() => import('../pages/authorize/authorizeInput/authorizeInput'));
const AuthorizeInfo = lazy(() => import('../pages/authorize/authorizeInfo/authorizeInfo'));
const ActiveList = lazy(() => import('../pages/authorize/activeList/activeList'));

const TodoList = lazy(() => import('../pages/todo/todoList'));
const TodoRule = lazy(() => import('../pages/todo/TodoRule'));

const DataManage = lazy(() => import('src/pages/doc/DocManage/DocManage'));
const DataCenter = lazy(() => import('src/pages/doc/DocCenter/DocCenter'));

const FaqCenterComponent = lazy(() => import("src/pages/faq/FaqCenter/FaqCenter"));
const FaqManagerComponent = lazy(() => import("src/pages/faq/FaqManage/FaqManage"));

const SearchComponent = lazy(() => import("src/pages/searchPage/searchPage"));

const NotFoundComponent = lazy(() => import("../views/NotFound.jsx"));
const Unauthorized = lazy(() => import("../views/Unauthorized"));
const Loading = lazy(() => import("../views/Loading"));

const CustomerReport = lazy(() => import("src/pages/CustomerReport"));

const isvCooperate = lazy(() => import("../pages/isvCooperate/isvCooperate/isvCooperate"));

const routes = [
  {
    component: HomeLayout,
    routes: [
      {
        path: '/',
        exact: true,
        render: () => <Redirect to={pathPrefix + "/login"} />,
      },
      {
        path: pathPrefix + "/main",
        component: SuspenseComponent(IndexComponent),
        routes: [
          {
            path: pathPrefix + "/main/index",
            name: "首页",
            index: 0,
            icon: "/images/icon/leftbar_type_nor.png",
            iconHover: "/images/icon/leftbar_type_sel.png",
            component: SuspenseComponent(HomeComponent),
          },
          {
            key: "wizard-product-center",  //作为新手引导步骤id标识
            path: pathPrefix + "/main/production/center",
            name: "产品中心",
            index: 1,
            icon: "/images/icon/leftbar_template_nor.png",
            iconHover: "/images/icon/leftbar_template_sel.png",
            component: SuspenseComponent(ProductCenter),
          },
          {
            path: pathPrefix + "/main/production/detail",
            index: 2,
            //name: "产品详情",
            component: SuspenseComponent(ProductDetail),
          },
          {
            path: pathPrefix + "/main/solution/center",
            name: "解决方案",
            icon: "/images/icon/solution.png",
            iconHover: "/images/icon/solution_sel.png",
            index: 3,
            component: SuspenseComponent(SolutionCenter, {
              category: "SOLUTION",
            }),
          },
          {
            path: pathPrefix + "/main/data/center",
            name: "资料中心",
            index: 17,
            icon: "/images/icon/leftbar_type_nor.png",
            iconHover: "/images/icon/leftbar_type_sel.png",
            component: SuspenseComponent(DataCenter),
          },
          {
            path: pathPrefix + "/main/case/center",
            name: "成功案例",
            index: 4,
            icon: "/images/icon/case.png",
            iconHover: "/images/icon/case_sel.png",
            component: SuspenseComponent(SolutionCenter, {
              category: "SUCCCASE",
            }),
          },
          {
            path: pathPrefix + "/main/solution/detail",
            //name: "解决方案,成功案例详情",
            component: SuspenseComponent(SolutionDetail),
          },
          // 代理商
          // {
          //   path: "/main/cart",
          //   name: "购物车",
          //   index: 9,
          //   icon: "/images/icon/icon_minicart_nor.png",
          //   iconHover: "/images/icon/icon_minicart_pre.png",
          //   component: SuspenseComponent(Cart),
          // },
          {
            path: pathPrefix + "/main/collection",
            name: "我的收藏",
            index: 6,
            icon: "/images/icon/leftbar_collection_nor.png",
            iconHover: "/images/icon/leftbar_collection_sel.png",
            component: SuspenseComponent(Collection),
          },
          {
            key: "wizard-project-admin",  //作为新手引导步骤id标识
            path: pathPrefix + '/main/project',
            name: '商机报备',
            index: 7,
            icon: '/images/icon/leftbar_customer_nor.png',
            iconHover: '/images/icon/leftbar_customer_sel.png',
            component: SuspenseComponent(ProductComponent),
            routes: [
              {
                path: pathPrefix + "/main/project/project",
                name: "项目管理",
                routes: [
                  {
                    path: pathPrefix + "/main/project/project/my",
                    name: "我的项目",
                    component: SuspenseComponent(ProjectComponent),
                  },
                  {
                    path: pathPrefix + "/main/project/project/config",
                    name: "项目属性管理",
                    component: SuspenseComponent(ProjectConfigComponent),
                  },
                ],
              },
            ],
          },
          {
            path: pathPrefix + '/main/quote-detail',
            // index: 8,
            component: SuspenseComponent(QuotationDetailPage),
          },
          {
            key: "wizard-quote-admin", //作为新手引导步骤id标识
            path: pathPrefix + '/main/quote',
            name: '报价管理',
            index: 9,
            icon: '/images/icon/leftbar_price_nor.png',
            iconHover: '/images/icon/leftbar_price_sel.png',
            component: SuspenseComponent(QuoteIndex),
            routes: [
              {
                path: pathPrefix + "/main/quote/index",
                component: FormalQuotation,
                name: "报价管理",
                routes: [
                  {
                    key: "wizard-quote-quick",  //作为新手引导步骤id标识
                    path: pathPrefix + "/main/quote/index/quick",
                    name: "快速报价",
                    component: QuickQuotation,
                  },
                  {
                    path: pathPrefix + "/main/quote/index/formal",
                    name: "报价单",
                    component: FormalQuotation,
                  },
                  {
                    key: 'wizard-quote-draft',
                    path: pathPrefix + "/main/quote/index/draft",
                    name: "草稿箱",
                    component: DraftQuotation,
                  },
                  {
                    path: pathPrefix + "/main/quote/index/trash",
                    name: "回收站",
                    component: TrashQuotation,
                  },
                ],
              },
              // {
              //   path: "/main/quote/project",
              //   component: FormalQuotation,
              //   name: "项目管理",
              //   routes: [
              //     {
              //       path: "/main/quote/project/my",
              //       name: "我的项目",
              //       component: SuspenseComponent(ProjectComponent),
              //     },
              //   ],
              // },
            ],
          },
          {
            path: pathPrefix + "/main/authorize",
            name: "授权管理",
            index: 10,
            icon: "/images/icon/leftbar_system_nor.png",
            iconHover: "/images/icon/leftbar_system_sel.png",
            component: SuspenseComponent(SystemComponent),
            routes: [
              {
                path: pathPrefix + "/main/authorize",
                name: "授权查看",
                icon: "/images/icon/nav_Customer info_nor.png",
                iconHover: "/images/icon/nav_Customer info_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/authorize/agent/view",
                    name: "授权录入记录",
                    component: SuspenseComponent(AuthorizeInput),
                  },
                  {
                    path: pathPrefix + "/main/authorize/info/view",
                    name: "授权数量统计",
                    component: SuspenseComponent(AuthorizeInfo),
                  },
                  {
                    path: pathPrefix + "/main/authorize/active/list",
                    name: "授权激活记录",
                    component: SuspenseComponent(ActiveList),
                  },
                ],
              },
            ],
          },
          {
            path: pathPrefix + "/main/release",
            name: "发布管理",
            index: 11,
            icon: "/images/icon/leftbar_system_nor.png",
            iconHover: "/images/icon/leftbar_system_sel.png",
            component: SuspenseComponent(SystemComponent),
            routes: [
              {
                path: pathPrefix + "/main/release/product",
                name: "报价发布",
                icon: "/images/icon/nav_Customer info_nor.png",
                iconHover: "/images/icon/nav_Customer info_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/release/product/quotation",
                    name: "报价发布",
                    component: SuspenseComponent(QuotationReleaseComponent),
                  }
                ],
              },
              {
                path: pathPrefix + "/main/release/doc",
                name: "文档发布",
                icon: "/images/icon/nav_Customer info_nor.png",
                iconHover: "/images/icon/nav_Customer info_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/release/doc/page",
                    name: "文档发布",
                    component: SuspenseComponent(DocReleaseComponent),
                  }
                ],
              },
              {
                path: pathPrefix + "/main/release/faq",
                name: "FAQ发布",
                icon: "/images/icon/nav_Customer info_nor.png",
                iconHover: "/images/icon/nav_Customer info_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/release/faq/page",
                    name: "FAQ发布",
                    component: SuspenseComponent(FaqReleaseComponent),
                  }
                ],
              },
              {
                path: pathPrefix + "/main/release/software",
                name: "设备发布管理",
                icon: "/images/icon/nav_Customer info_nor.png",
                iconHover: "/images/icon/nav_Customer info_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/release/software/version",
                    name: "软件版本发布",
                    component: SuspenseComponent(SoftwareReleaseComponent),
                  },
                  {
                    path: pathPrefix + "/main/release/software/patch",
                    name: "补丁发布",
                    component: SuspenseComponent(PatchReleaseComponent),
                  },
                  {
                    path: pathPrefix + "/main/release/software/manual",
                    name: "手册发布",
                    component: SuspenseComponent(ManualReleaseComponent),
                  },
                  {
                    path: pathPrefix + "/main/release/software/notice",
                    name: "通知管理",
                    component: SuspenseComponent(SoftwareMessageComponent),
                  }
                ],
              },
            ],
          },
          {
            path: pathPrefix + '/main/strategy',
            name: '版本管理',
            index: 12,
            icon: '/images/icon/leftbar_customer_nor.png',
            iconHover: '/images/icon/leftbar_customer_sel.png',
            component: SuspenseComponent(SideLayout),
            routes: [
              {
                path: pathPrefix + "/main/strategy/strategy",
                name: "项目管理",
                routes: [
                  {
                    path: pathPrefix + "/main/strategy/strategy/version-list",
                    name: '版本清单',
                    component: SuspenseComponent(VersionListComponent),
                  },
                  {
                    path: pathPrefix + "/main/strategy/strategy/search",
                    name: '升级策略',
                    component: SuspenseComponent(StrategyComponent),
                  },
                ],
              },
            ],
          },
          // 产品变更说明
          {
            path: pathPrefix + '/main/product-change',
            name: '产品公告',
            index: 13,
            icon: '/images/icon/leftbar_customer_nor.png',
            iconHover: '/images/icon/leftbar_customer_sel.png',
            component: SuspenseComponent(ProductChange),
          },
          {
            path: pathPrefix + "/main/faq/center",
            name: "FAQ",
            index: 14,
            icon: "/images/icon/leftbar_type_nor.png",
            iconHover: "/images/icon/leftbar_type_sel.png",
            component: SuspenseComponent(FaqCenterComponent),
          },
          {
            path: pathPrefix + "/main/faq/manager",
            name: "FAQ管理",
            index: 15,
            icon: "/images/icon/leftbar_type_nor.png",
            iconHover: "/images/icon/leftbar_type_sel.png",
            component: SuspenseComponent(FaqManagerComponent),
          },
          {
            path: pathPrefix + "/main/data/manage",
            name: "资料管理",
            index: 16,
            icon: "/images/icon/leftbar_type_nor.png",
            iconHover: "/images/icon/leftbar_type_sel.png",
            component: SuspenseComponent(DataManage),
          },
          {
            path: pathPrefix + '/main/usercenter',
            name: '用户中心',
            index: 18,
            icon: '/images/icon/leftbar_customer_nor.png',
            iconHover: '/images/icon/leftbar_customer_sel.png',
            component: SuspenseComponent(UserCenter),
            routes: [
              {
                path: pathPrefix + '/main/usercenter/usercenter',
                name: '用户中心',
                routes: [{
                  path: pathPrefix + '/main/usercenter/usercenter/account',
                  name: '账号信息',
                  component: AccountInfo,
                }, {
                  path: pathPrefix + '/main/usercenter/usercenter/user',
                  name: '个人信息',
                  component: UserInfo,
                }, {
                  path: pathPrefix + '/main/usercenter/usercenter/company',
                  name: '公司信息',
                  component: CompanyInfo,
                }, {
                  path: pathPrefix + "/main/usercenter/usercenter/QAshow",
                  name: 'QA信息',
                  component: SuspenseComponent(QaShowComponent),
                }],
              }
            ]
          },
          //产品管理
          {
            key: "wizard-product-admin", //作为新手引导步骤id标识
            path: pathPrefix + "/main/product-manager",
            name: "方案管理",
            index: 19,
            icon: "/images/icon/leftbar_product_nor.png",
            iconHover: "/images/icon/leftbar_product_sel.png",
            component: SuspenseComponent(ProductComponent),
            routes: [
              {
                path: pathPrefix + "/main/product-manager/admin",
                name: "产品管理",
                icon: "/images/icon/nav_product management_nor.png",
                iconHover: "/images/icon/nav_product management_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/product-manager/admin/all",
                    name: "所有分类",
                    component: SuspenseComponent(ProductAdminComponent),
                  },
                ],
              },
              {
                path: pathPrefix + "/main/product-manager/suite",
                name: "套件管理",
                routes: [
                  {
                    path: pathPrefix + "/main/product-manager/suite/all",
                    name: "套件管理",
                    component: SuspenseComponent(ProductSuite),
                  },
                ],
              },
              {
                path: pathPrefix + "/main/product-manager/solution",
                name: "方案案例",
                routes: [
                  {
                    path: pathPrefix + "/main/product-manager/solution/solution",
                    name: "解决方案",
                    component: SuspenseComponent(SolutionComponent, {
                      category: "SOLUTION",
                    }),
                  },
                  {
                    path: pathPrefix + "/main/product-manager/solution/case",
                    name: "成功案例",
                    component: SuspenseComponent(SolutionComponent, {
                      category: "SUCCCASE",
                    }),
                  },
                ],
              },
              {
                path: pathPrefix + "/main/product-manager/promotion",
                name: "促销政策",
                routes: [
                  {
                    path: pathPrefix + "/main/product-manager/promotion/all",
                    name: "促销政策",
                    component: SuspenseComponent(Promotion),
                  },
                ],
              },
              {
                path: pathPrefix + "/main/product-manager/shipment",
                name: "出货信息",
                routes: [
                  {
                    path: pathPrefix + "/main/product-manager/shipment/barcode",
                    name: "出货条码查询",
                    component: SuspenseComponent(ShipmentBarcode),
                  },
                ],
              },
            ],
          },
          {
            path: pathPrefix + "/main/agent",
            name: "客户管理",
            index: 20,
            icon: "/images/icon/leftbar_customer_nor.png",
            iconHover: "/images/icon/leftbar_customer_sel.png",
            component: SuspenseComponent(AgentComponent),
            routes: [
              {
                path: pathPrefix + "/main/agent/user",
                name: "代理商",
                icon: "/images/icon/nav_Customer info_nor.png",
                iconHover: "/images/icon/nav_Customer info_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/agent/user/group",
                    name: "代理商管理",
                    component: SuspenseComponent(AgentManageComponent),
                  },
                ],
              },
            ],
          },
          {
            path: pathPrefix + "/main/system",
            name: "系统管理",
            index: 21,
            icon: "/images/icon/leftbar_system_nor.png",
            iconHover: "/images/icon/leftbar_system_sel.png",
            component: SuspenseComponent(SystemComponent),
            routes: [
              {
                path: pathPrefix + "/main/system/user",
                name: "用户管理",
                icon: "/images/icon/nav_Customer info_nor.png",
                iconHover: "/images/icon/nav_Customer info_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/system/user/group",
                    name: "用户组管理",
                    component: SuspenseComponent(GroupComponent),
                  },
                  {
                    path: pathPrefix + "/main/system/user/manager",
                    name: "管理员配置",
                    component: SuspenseComponent(ManagerComponent),
                  },
                  {
                    path: pathPrefix + "/main/system/user/sale",
                    name: "渠道经理管理",
                    component: SuspenseComponent(SaleComponent),
                  },
                  {
                    path: pathPrefix + "/main/system/user/special",
                    name: "特殊权限管理",
                    component: SuspenseComponent(SpecialRight),
                  },
                ],
              },
              {
                path: pathPrefix + "/main/system/manager",
                name: '基础数据管理',
                icon: '/images/icon/nav_Customer info_nor.png',
                iconHover: '/images/icon/nav_Customer info_sel.png',
                routes: [
                  // {
                  //   path: "/main/system/manager/model",
                  //   name: '产品分类',
                  //   component: SuspenseComponent(ProductModelComponent),
                  // },
                  {
                    path: pathPrefix + "/main/system/manager/QA",
                    name: 'QA',
                    component: SuspenseComponent(QaComponent),
                  },
                  {
                    path: pathPrefix + "/main/system/manager/contact",
                    name: '联系人',
                    component: SuspenseComponent(ContactComponent),
                  },
                  {
                    path: pathPrefix + "/main/system/manager/manual",
                    name: '操作指南',
                    component: SuspenseComponent(ManualComponent, {
                      belong: "OPERATIONGUIDE",
                    }),
                  },
                  {
                    path: pathPrefix + "/main/system/manager/unified",
                    name: '公告文件',
                    component: SuspenseComponent(ManualComponent, {
                      belong: "NOTICEFILE",
                    }),
                  },
                  {
                    path: pathPrefix + "/main/system/manager/version",
                    name: '版本更新',
                    component: SuspenseComponent(VersionComponent),
                  }
                ]
              },
              {
                path: pathPrefix + "/main/system/manager/log",
                name: '日志管理',
                icon: '/images/icon/nav_Customer info_nor.png',
                iconHover: '/images/icon/nav_Customer info_sel.png',
                routes: [
                  {
                    path: pathPrefix + "/main/system/manager/log/list",
                    name: '操作日志',
                    component: SuspenseComponent(OpeLogComponent),
                  }
                ]
              },
              {
                path: pathPrefix + "/main/system/manager/setting",
                name: '配置管理',
                icon: '/images/icon/nav_Customer info_nor.png',
                iconHover: '/images/icon/nav_Customer info_sel.png',
                routes: [
                  {
                    path: pathPrefix + "/main/system/manager/setting/system",
                    name: '系统配置',
                    component: SuspenseComponent(SettingComponent),
                  },
                  {
                    path: pathPrefix + "/main/system/manager/setting/authorize",
                    name: '授权配置',
                    component: SuspenseComponent(AuthSettingComponent),
                  },
                  {
                    path: pathPrefix + "/main/system/manager/setting/todo-rule",
                    name: '部门经理审批规则',
                    component: SuspenseComponent(TodoRule),
                  }
                ]
              },
            ],
          },
          {
            path: pathPrefix + "/main/todo",
            name: "我的待办",
            index: 22,
            icon: "/images/icon/leftbar_system_nor.png",
            iconHover: "/images/icon/leftbar_system_sel.png",
            component: SuspenseComponent(TodoList),
          },
          {
            path: pathPrefix + '/main/about',
            name: '关于我们',
            index: 23,
            icon: '/images/icon/leftbar_customer_nor.png',
            iconHover: '/images/icon/leftbar_customer_sel.png',
            component: SuspenseComponent(SystemComponent),
            routes: [
              {
                path: pathPrefix + '/main/about/manager/operation/manual',
                name: '操作指南',
                iconHover: "/images/icon/nav_Customer info_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/about/manager/operation/manual",
                    name: "操作指南",
                    component: SuspenseComponent(ManualListComponent, {
                      belong: "OPERATIONGUIDE",
                    }),
                  },
                ],
              },
              {
                path: pathPrefix + '/main/about/version/log',
                name: '更新日志',
                iconHover: "/images/icon/nav_Customer info_sel.png",
                routes: [
                  {
                    path: pathPrefix + "/main/about/version/log",
                    name: "系统版本",
                    component: SuspenseComponent(VersionListCompoment),
                  },
                ],
              }
            ]
          },
          {
            key: "wizard-isv",
            path: pathPrefix + "/main/isv",
            name: "ISV合作",
            index: 24,
            icon: "/images/icon/leftbar_type_nor.png",
            iconHover: "/images/icon/leftbar_type_sel.png",
            component: SuspenseComponent(isvCooperate),
          },
          {
            path: pathPrefix + "/main/search",
            component: SuspenseComponent(SearchComponent),
          },
          {
            path: pathPrefix + "/main/customer",
            name: '客户报备',
            component: SuspenseComponent(CustomerReport),
          },
          {
            path: pathPrefix + '/main/404',
            component: SuspenseComponent(NotFoundComponent),
          },
          {
            path: pathPrefix + '/main/403',
            component: SuspenseComponent(Unauthorized),
          },
          {
            path: pathPrefix + '/main/loading',
            component: SuspenseComponent(Loading),
          }
        ]
      },
      {
        path: pathPrefix + "/login",
        component: SuspenseComponent(LoginComponent),
      },
      {
        path: pathPrefix + "/404",
        component: SuspenseComponent(NotFoundComponent),
      },
      {
        path: pathPrefix + "/403",
        component: SuspenseComponent(Unauthorized),
      },
    ],
  },
];
export default routes;
